<template>
<div class="vue-app">
    <div class="container form-container">
        <div class="row">
            <div class="col-12 col-md-4 my-3">
                <div class="patient-education-content">
                    <h2 :class="post_title_h_style">{{ post_title }}</h2>
                    <div v-html="post_description"></div>
                </div>
            </div>
            <div class="col-12 col-md-8 my-3">
                <form id="patient-education-search-form">
                    <div class="form-row mb-3">
                        <div class="col-12">
                            <h5 class="mb-2">Search by Keyword</h5>
                            <input id="keyword" type="text" class="form-control"
                                placeholder="Search" v-model="form.keyword" ref="keyword">
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-12 col-md-6">
                            <h5 class="mb-2">Search by Cancer Type</h5>
                            <multiselect
                                id="search-cancer-type"
                                ref="search_cancer_type"
                                v-model="form.cancer_type"
                                :options="cancer_types"
                                :multiple="true"
                                placeholder="Types of Cancer:"
                                :close-on-select="false"
                                :clear-on-select="true"
                                selectLabel="Press enter or click to select"
                                deselectLabel="Press enter or click to remove"
                                label="text"
                                track-by="id"
                                :maxHeight="dropdownHeight"
                                @open="onMultiselectOpen"
                                @close="onMultiselectClose"
                            >
                            </multiselect>
                        </div>
                        <div class="col-12 col-md-6">
                            <h5 class="mb-2">Search by Topic</h5>
                            <multiselect
                                id="search-topic"
                                ref="search_topic"
                                v-model="form.topic"
                                :options="topics"
                                :multiple="true"
                                placeholder="Topics:"
                                :close-on-select="false"
                                :clear-on-select="true"
                                selectLabel="Press enter or click to select"
                                deselectLabel="Press enter or click to remove"
                                label="text"
                                track-by="id"
                                :maxHeight="dropdownHeight"
                                @open="onMultiselectOpen"
                                @close="onMultiselectClose"
                            >
                            </multiselect>
                        </div>
                    </div>
                    <div class="form-row mt-3">
                        <button type="submit" @click.prevent="showCards(true)" class="btn btn-primary mr-1">Search</button>
                        <button type="button" @click.prevent="resetForm()" class="btn btn-dark mr-1">Reset Form</button>
                        <a  :href="you_tube_link" target="_blank" class="btn btn-primary">Subscribe to our YouTube channel</a>
                    </div>
                </form>
            </div>
        </div>
    </div>
    <div class="container-fluid clip-path-ellipse-concave-square" id="videos-results-wrap">
        <div class="container vue-search-results py-3">
            <div class="row">
                <div class="col-12">
                    <h2 class="h3">Search Results</h2>
                    <p>Showing {{ min_count }} - {{ count }} of {{ total_count }} results</p>
                </div>
            </div>
            <div class="row" id="videos-results">
                <patient-results v-for="post in patient_education" :key="post['title']" :patient_education_video="post"></patient-results>
                <div class="col-12" v-bind:class="{'d-none': $store.state.results_count || !initialized }">{{ no_results_message }}</div>
            </div>
        </div>
        <div class="container py-2" v-bind:class="{'d-none': has_more }">
            <div class="row justify-content-center">
                <button type="button" @click.prevent="showMoreCards()" class="btn btn-primary">Load More Results</button>
            </div>
        </div>
    </div>
     <div class="modal-wrap" @click.prevent="onModalOutsideClick($event)">
        <div class="youtube-modal p-3">
            <div class="modal-body"></div>
            <div class="modal-close-wrap">
                <div @click.prevent="closeModal()" class="modal-close btn btn-dark">
                    Close
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import ApiCalls from "../../api/apiServices"
import Helpers from "../../scripts/helpers"
import VideoResults from "../results/wf-patient-education-results.vue"
import { mapMutations } from 'vuex'

export default {
    data() {
        return {
            post_title: window.patient_education_search ? window.patient_education_search.form_title : '',
            post_title_h_style: window.patient_education_search ? window.patient_education_search.form_title_h_style : 'h4',
            post_description: window.patient_education_search ? window.patient_education_search.form_description : '',
            you_tube_link: '',
            form: {
                keyword: "",
                cancer_type: [],
                topic: [],
            },
            patient_education: '',
            cancer_types: [],
            topics: [],
            dropdownHeight: 200,
            no_results_message: window.patient_education_search ? window.patient_education_search.no_results_message : 'No results found.',
            initialized: false
        }
    },
    computed: {
        min_count() {
            return this.$store.state.results_count == 0 ? 0 : 1
        },
        has_more() {
            return this.$store.state.results_count <= this.$store.state.patient_videos_shown_count
        },
        count() {
            return Math.min(this.$store.state.patient_videos_shown_count, this.$store.state.results_count)
        },
        total_count(){
            return this.$store.state.results_count
        }
    },
    methods: {
        ...mapMutations(
            ['incrementCount', 'resetCount', 'showMore', 'showMorePatientVideos']
        ),
        retrievePatientEducationVideos(){
            ApiCalls.getBasicEndpoint('patient-education').then((data) => {
                if( data != null ){
                    for (var post in data) {
                        this.incrementCount(this)
                    }
                    this.$set(this, 'patient_education', data)
                    setTimeout( this.showCards, 400)
                }
                this.$set(this, 'initialized', true);
            })
        },
        retrieveDropdowns(){
            this.getDropdownValues(window.cancer_types).then((data) => {
                if( data != null ) {
                    Object.values(data).forEach(result => {
                        let text = result.text
                        let cancer_type = {
                            text: text,
                            value: text,
                            id: result.id
                        }
                        this.cancer_types.push(cancer_type)
                    })
                }
            })
            this.getDropdownValues(window.topics).then((data) => {
                if( data != null ) {
                    Object.values(data).forEach(result => {
                        let text = result.text
                        let topic = {
                            text: text,
                            value: text,
                            id: result.id
                        }
                        this.topics.push(topic)
                    })
                }
            })
        },
        getDropdownValues(type){
            return new Promise((resolve, reject) => {
                resolve(type)
            })
        },
        retrieveYouTubeData(){
            ApiCalls.getBasicEndpoint('youtube-link').then((data) => {
                if(data != null){
                    this.you_tube_link = data
                }
            })
        },
        showCards(scroll = false){
            let cards = document.querySelectorAll('#videos-results .card-wrap')
            let count = 0
            this.resetCount()
            if(cards != null && cards.length > 0){
                [...cards].forEach((card) => {
                    let valid_result = this.filterCards(card)
                    if(count < this.$store.state.patient_videos_shown_count && valid_result) {
                        card.classList.add('active')
                        count++
                    } else {
                        card.classList.remove('active')
                    }
                    if (valid_result) {
                        this.incrementCount()
                    }
                })
                if (scroll) {
                    document.querySelector('.vue-search-results').scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            } else {
                setTimeout( this.showCards, 400)
            }
        },
        closeModal(){
            let modal = document.querySelector('.modal-wrap')
            let modalBody = modal.querySelector('.modal-body')
            modalBody.innerHTML = ''
            modal.classList.remove('active')
        },
        resetForm(){
            this.form = {
                keyword: "",
                cancer_type: [],
                topic: []
            }
        },
        showMoreCards(){
            this.showMorePatientVideos(this)
            this.showCards()
        },
        filterCards(card){
            let card_cancer_type_arr = card.dataset.cancerTypes.split(", ")
            let card_topic_arr = card.dataset.topics.split(", ")
            let filtered_type = false
            let filtered_topic = false
            let filtered_keyword = true;
            let keywords = this.form.keyword.trim().toLowerCase();
            let form_type = this.form.cancer_type
            let form_topic = this.form.topic

            if (keywords.length) {
                let terms = keywords.split(/\s/);
                let comp = card.textContent.toLowerCase();
                terms.forEach((term) => {
                    filtered_keyword = filtered_keyword && comp.indexOf(term) >= 0;
                })
                console.log(card.textContent, terms, filtered_keyword);
            }

            if(form_type.length > 0){
                card_cancer_type_arr.forEach(function(type){
                    form_type.forEach(function(c_type){
                        if(type == c_type.value) {
                            filtered_type = true
                        }
                    })
                })
            } else {
                filtered_type = true
            }
            if(form_topic.length > 0){
                card_topic_arr.forEach(function(topic){
                    form_topic.forEach(function(t_topic){
                        if(topic == t_topic.value) {
                            filtered_topic = true
                        }
                    })
                })
            } else {
                filtered_topic = true
            }
            if(filtered_type && filtered_topic && filtered_keyword){
                return true
            } else {
                return false
            }
        },
        onModalOutsideClick(evt) {
            let click_outside = true
            let ref = evt.target
            while (click_outside && ref.parentElement) {
                if (ref.classList && ref.classList.contains('youtube-modal')) {
                    click_outside = false;
                }
                ref = ref.parentElement
            }

            if (click_outside) {
                this.closeModal()
            }
        },

        findSpacingTarget() {
            return this.$el.querySelector(".form-container")
        },
        findPositionTop(elem) {
            let offsetTop = 0;
            do {
                offsetTop += elem.offsetTop
            } while (elem = elem.offsetParent)
            return offsetTop;
        },

        onMultiselectOpen(id) {
            let spacingTarget = this.findSpacingTarget()
            if (spacingTarget) {
                let dropdownField = this.$el.querySelector("#" + id).closest('.multiselect')
                let ddtop = this.findPositionTop(dropdownField) - this.findPositionTop(spacingTarget)
                spacingTarget.style.marginBottom = Math.max(0, (ddtop + dropdownField.offsetHeight + this.dropdownHeight) - spacingTarget.offsetHeight) + "px"
            }
        },

        onMultiselectClose() {
            let spacingTarget = this.findSpacingTarget()
            if (spacingTarget) {
                spacingTarget.style.marginBottom = 0
            }
        },
    },
    created() {
        this.retrieveDropdowns();
        this.retrievePatientEducationVideos();
        this.retrieveYouTubeData();
    },
    mounted() {
        ["search_cancer_type", "search_topic"].forEach((item) => {
          this.$refs[item].$refs.search.setAttribute("autocomplete", "off");
        })
    },
    components: {
        'patient-results' : VideoResults
    }
}
</script>